export default __webpack_public_path__ + "static/media/eyeThin.edb20b47.svg";